export default {
    connectedGooglePlayAccounts(state) {
        return state.connectedGooglePlayAccounts
    },
    authUrl(state) {
        return state.authUrl;
    },
    packages(state){
        return state.packages;
    }
}